var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_18050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6893C0.0186989 8.9378 0.498637 7.64758 1.52707 6.60044C3.33463 4.75549 5.16089 2.91677 7.01208 1.11544C8.58278 -0.411632 11.0635 -0.355535 12.5968 1.19024C14.1176 2.72355 14.155 5.19803 12.6404 6.75627C11.0697 8.3706 9.46786 9.96001 7.85976 11.5369C6.89365 12.4844 5.37904 12.447 4.4441 11.4871C3.52162 10.5459 3.51539 9.04376 4.45033 8.09012C5.40397 7.11778 6.37008 6.15791 7.33619 5.20426C7.71017 4.83029 8.23997 4.82405 8.58901 5.16063C8.95053 5.51591 8.95053 6.04571 8.56408 6.43839C7.65407 7.36087 6.72536 8.27088 5.81535 9.19959C5.69692 9.32425 5.57226 9.47384 5.52863 9.62966C5.44137 9.92261 5.54733 10.1844 5.80912 10.3589C6.05843 10.5272 6.32022 10.521 6.56954 10.3589C6.6381 10.3153 6.70043 10.253 6.75653 10.1969C8.2836 8.66979 9.81691 7.14894 11.3377 5.61564C12.5532 4.38774 12.067 2.36827 10.4464 1.86963C9.62992 1.61408 8.86326 1.7699 8.25243 2.36827C6.40748 4.18206 4.56876 6.00208 2.76743 7.85327C1.38372 9.28062 1.42735 11.618 2.80483 13.0453C4.21348 14.5101 6.50721 14.6534 8.01558 13.3196C8.8134 12.6152 9.53642 11.8174 10.3031 11.0695C10.8266 10.5584 11.6307 10.789 11.7865 11.4871C11.8551 11.78 11.7741 12.048 11.5621 12.26C10.7768 13.0453 10.0351 13.8868 9.18738 14.5973C7.39852 16.1119 5.35411 16.4174 3.22867 15.4388C1.1157 14.4727 0.0872614 12.715 0 10.6893Z",
    fill: "#848FAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_18050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7561,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileItem);
export default __webpack_public_path__ + "static/media/fileItem.86900cec48909b997af4dea4d5691b01.svg";
export { ForwardRef as ReactComponent };